import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import './CategoriesListPage.css'; // We'll create this CSS file

const categories = [
  { id: 'cold-knowledge', name: '冷知识', description: '科学、历史、文化、人体、语言等奇怪但真实的知识' },
  { id: 'strange-questions', name: '怪问题', description: '一些脑洞问题、哲学式问题、童年幻想类问题' },
  { id: 'anti-common-sense', name: '反常识', description: '我们习以为常的错误认知' },
  { id: 'useless-inventions', name: '无用发明', description: '介绍现实中奇怪却真的存在的东西' },
  { id: 'ai-generated', name: 'AI瞎编', description: '由 AI 生成的冷知识（带提示说明，供娱乐）' },
];

function CategoriesListPage() {
  return (
    <div>
      <Navbar />
      <div className="categories-list-page">
        <h1>所有分类</h1>
        <div className="categories-grid">
          {categories.map(category => (
            <Link to={`/categories/${category.id}`} key={category.id} className="category-card">
              <h2>{category.name}</h2>
              <p>{category.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoriesListPage;
